// Platform-aware biometric labeling. WebAuthn always delegates to the OS-native
// prompt (Face ID, Touch ID, Android face/fingerprint, Windows Hello) — the web
// cannot detect WHICH biometric is enrolled, so labels adapt per platform.
import { Fingerprint, ScanFace } from "lucide-react";

export function detectBiometricPlatform() {
  const ua = navigator.userAgent || "";
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (/iPhone|iPod/.test(ua)) return { os: "ios", method: "Face ID or Touch ID", Icon: ScanFace };
  if (/iPad/.test(ua) || iPadOS) return { os: "ios", method: "Face ID or Touch ID", Icon: ScanFace };
  if (/Android/i.test(ua)) return { os: "android", method: "biometrics", hint: "face or fingerprint", Icon: ScanFace };
  if (/Macintosh/.test(ua)) return { os: "mac", method: "Touch ID", Icon: Fingerprint };
  if (/Windows/.test(ua)) return { os: "windows", method: "Windows Hello", Icon: ScanFace };
  return { os: "other", method: "biometrics", Icon: Fingerprint };
}

export function biometricLabel(action) {
  const { method } = detectBiometricPlatform();
  return `${action} with ${method}`;
}

export function BiometricIcon({ className = "w-5 h-5" }) {
  const { Icon } = detectBiometricPlatform();
  return <Icon className={className} strokeWidth={1.5} />;
}
